import React, { FC, ReactNode } from 'react';
import { useState } from 'react';
import { useCart } from '~Components/CartProvider';
import { useButton } from '~Hooks';
import { BlackButton } from '~Scenes/Handy/styles';
import TypeChanger from '~ComponentsImproved/TSR/TypeChanger';

interface Props {
  children: ReactNode;
}

const ChangeCourseButton: FC<Props> = ({ children }) => {
  const [showModal, setShowModal] = useState<boolean>(false);
  const cart = useCart();

  const button = useButton({
    onClick: () => setShowModal(true),
  });

  return (
    <>
      <BlackButton {...button}>{children}</BlackButton>
      {showModal && (
        <TypeChanger
          onChange={(courseType) => {
            cart.selectedItems.changeCourseType(courseType);
            cart.setSelectedItems([]);
            setShowModal(false);
          }}
          onClose={() => setShowModal(false)}
        />
      )}
    </>
  );
};

export default ChangeCourseButton;
